import { Renderer } from '@unseenco/taxi';
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { isDEVMODE, viewStorage } from '../_globals'

export default class EspacePro extends Renderer {

  initialLoad() {
    this.onEnter()
  }

  onEnter() {
    this.DOM = {

    }

    this.init()
  }

  init() {

  }

  onLeaveCompleted() {

  }
}
